"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ImageEditor,
  ToggleEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokHeroEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Tag */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <TextEditor
              label="Tag Line"
              value={content.tag}
              onChange={(v) => onContentChange?.({ ...content, tag: v })}
              placeholder="Trusted by 1850+ Educators Worldwide"
            />
          </div>

          {/* Title */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Title</h4>
            <TextEditor
              label="First Part"
              value={content.title}
              onChange={(v) => onContentChange?.({ ...content, title: v })}
              placeholder="Largest"
            />
            <TextEditor
              label="Highlighted"
              value={content.highlightText}
              onChange={(v) => onContentChange?.({ ...content, highlightText: v })}
              placeholder="Education Platform"
            />
            <TextEditor
              label="Ending"
              value={content.titleEnd}
              onChange={(v) => onContentChange?.({ ...content, titleEnd: v })}
              placeholder="for Online Learning"
            />
          </div>

          {/* Description */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <TextEditor
              label="Description"
              value={content.text}
              onChange={(v) => onContentChange?.({ ...content, text: v })}
              placeholder="Instacks is a powerful platform to Create and Share Online Courses..."
              multiline
            />
          </div>

          {/* CTA Buttons */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Buttons</h4>
            <TextEditor
              label="Primary Button"
              value={content.primaryBtnText}
              onChange={(v) => onContentChange?.({ ...content, primaryBtnText: v })}
              placeholder="Explore Courses"
            />
            <TextEditor
              label="Secondary Button"
              value={content.secondaryBtnText}
              onChange={(v) => onContentChange?.({ ...content, secondaryBtnText: v })}
              placeholder="Learn More"
            />
          </div>

          {/* Hero Images - Left Column */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Left Column Images</h4>
            <ImageEditor
              label="Image 1"
              value={content.leftColumnImages?.[0] || "/assets/img/hero/hero-img-1.png"}
              onChange={(v) => {
                const images = content.leftColumnImages || ["/assets/img/hero/hero-img-1.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-6.png"];
                const newImages = [...images];
                newImages[0] = v;
                onContentChange?.({ ...content, leftColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 2"
              value={content.leftColumnImages?.[1] || "/assets/img/hero/hero-img-2.png"}
              onChange={(v) => {
                const images = content.leftColumnImages || ["/assets/img/hero/hero-img-1.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-6.png"];
                const newImages = [...images];
                newImages[1] = v;
                onContentChange?.({ ...content, leftColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 3"
              value={content.leftColumnImages?.[2] || "/assets/img/hero/hero-img-3.png"}
              onChange={(v) => {
                const images = content.leftColumnImages || ["/assets/img/hero/hero-img-1.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-6.png"];
                const newImages = [...images];
                newImages[2] = v;
                onContentChange?.({ ...content, leftColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 4"
              value={content.leftColumnImages?.[3] || "/assets/img/hero/hero-img-4.png"}
              onChange={(v) => {
                const images = content.leftColumnImages || ["/assets/img/hero/hero-img-1.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-6.png"];
                const newImages = [...images];
                newImages[3] = v;
                onContentChange?.({ ...content, leftColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 5"
              value={content.leftColumnImages?.[4] || "/assets/img/hero/hero-img-5.png"}
              onChange={(v) => {
                const images = content.leftColumnImages || ["/assets/img/hero/hero-img-1.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-6.png"];
                const newImages = [...images];
                newImages[4] = v;
                onContentChange?.({ ...content, leftColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 6"
              value={content.leftColumnImages?.[5] || "/assets/img/hero/hero-img-6.png"}
              onChange={(v) => {
                const images = content.leftColumnImages || ["/assets/img/hero/hero-img-1.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-6.png"];
                const newImages = [...images];
                newImages[5] = v;
                onContentChange?.({ ...content, leftColumnImages: newImages });
              }}
            />
          </div>

          {/* Hero Images - Right Column */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Right Column Images</h4>
            <ImageEditor
              label="Image 1"
              value={content.rightColumnImages?.[0] || "/assets/img/hero/hero-img-6.png"}
              onChange={(v) => {
                const images = content.rightColumnImages || ["/assets/img/hero/hero-img-6.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-1.png"];
                const newImages = [...images];
                newImages[0] = v;
                onContentChange?.({ ...content, rightColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 2"
              value={content.rightColumnImages?.[1] || "/assets/img/hero/hero-img-5.png"}
              onChange={(v) => {
                const images = content.rightColumnImages || ["/assets/img/hero/hero-img-6.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-1.png"];
                const newImages = [...images];
                newImages[1] = v;
                onContentChange?.({ ...content, rightColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 3"
              value={content.rightColumnImages?.[2] || "/assets/img/hero/hero-img-4.png"}
              onChange={(v) => {
                const images = content.rightColumnImages || ["/assets/img/hero/hero-img-6.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-1.png"];
                const newImages = [...images];
                newImages[2] = v;
                onContentChange?.({ ...content, rightColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 4"
              value={content.rightColumnImages?.[3] || "/assets/img/hero/hero-img-3.png"}
              onChange={(v) => {
                const images = content.rightColumnImages || ["/assets/img/hero/hero-img-6.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-1.png"];
                const newImages = [...images];
                newImages[3] = v;
                onContentChange?.({ ...content, rightColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 5"
              value={content.rightColumnImages?.[4] || "/assets/img/hero/hero-img-2.png"}
              onChange={(v) => {
                const images = content.rightColumnImages || ["/assets/img/hero/hero-img-6.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-1.png"];
                const newImages = [...images];
                newImages[4] = v;
                onContentChange?.({ ...content, rightColumnImages: newImages });
              }}
            />
            <ImageEditor
              label="Image 6"
              value={content.rightColumnImages?.[5] || "/assets/img/hero/hero-img-1.png"}
              onChange={(v) => {
                const images = content.rightColumnImages || ["/assets/img/hero/hero-img-6.png", "/assets/img/hero/hero-img-5.png", "/assets/img/hero/hero-img-4.png", "/assets/img/hero/hero-img-3.png", "/assets/img/hero/hero-img-2.png", "/assets/img/hero/hero-img-1.png"];
                const newImages = [...images];
                newImages[5] = v;
                onContentChange?.({ ...content, rightColumnImages: newImages });
              }}
            />
          </div>
        </>
      }
      styleFields={
        <>
          {/* Additional style fields can go here */}
        </>
      }
    />
  );
}
